/**
 * specifically opens dialog/login
 *
 * $('a.login').click(loginDialog.open);
 */
define('all/player/login-dialog',['jquery', 'all/dialog', 'all/player/login', 'all/slidingContentWrapper'], function($, dialog, login, slidingContentWrapper) {
	'use strict';

	function open(onSuccess) {
		onSuccess = onSuccess || $.noop;
		dialog.load('login', {}, function() {
			var $loginDialog = $(this);
			login.init($loginDialog.find('#login-dialog'), onSuccess);
			$loginDialog.find('a.registration').click(slidingContentWrapper.showSlidingSignup);
		});
	}

	return {
		open: open
	};
});

